const TECHNICAL_ERROR = "요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.";

const translations = [
  [/invalid login credentials/i, "아이디 혹은 비밀번호를 잘못입력하였습니다."],
  [/email not confirmed/i, "이메일 인증이 완료되지 않았습니다."],
  [/user already registered|email already (?:exists|registered)|duplicate key.*email/i, "이미 등록된 이메일입니다."],
  [/user is banned|user_banned/i, "아직 계정 이용이 승인되지 않았습니다."],
  [/rate limit|too many requests/i, "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요."],
  [/jwt expired|invalid jwt|session.*expired/i, "로그인 시간이 만료되었습니다. 다시 로그인해 주세요."],
  [/failed to fetch|networkerror|network request failed|fetch failed/i, "네트워크 연결을 확인한 뒤 다시 시도해 주세요."],
  [/row.level security|permission denied|42501|not authorized|unauthorized|forbidden/i, "접근 권한이 없습니다. 계정 권한을 확인해 주세요."],
  [/schema cache|could not find the .* column|relation .* does not exist/i, "서버 데이터 구조가 현재 화면과 일치하지 않습니다. 관리자에게 문의해 주세요."],
  [/non.2xx|edge function|function.*failed|internal server error|service unavailable/i, "서버 요청에 실패했습니다. 잠시 후 다시 시도해 주세요."],
];

export function userErrorMessage(error) {
  const message = typeof error === "string" ? error : error?.message || "";
  const match = translations.find(([pattern]) => pattern.test(message));
  if (match) return match[1];
  const withoutProductTerms = message.replace(/\b(?:Solapi|SMS|API|Key|Secret|DB|SQL|ID|URL|RLS|PDF|CSV|AI|JWT|Network)\b/gi, "");
  if (/[가-힣]/.test(message) && !/[a-z]{3,}/i.test(withoutProductTerms)) {
    return message;
  }
  return TECHNICAL_ERROR;
}

export function localizeAlertMessage(value) {
  const message = String(value ?? "");
  const match = message.match(/^([^\n:：]{1,100}(?:실패|오류|문제|못했습니다|않았습니다)[^\n:：]*[:：]\s*)([\s\S]+)$/);
  if (match) return match[1] + userErrorMessage(match[2]);
  if (/[가-힣]/.test(message)) return message;
  return userErrorMessage(message);
}

export function showUserAlert(message) {
  return window.alert(localizeAlertMessage(message));
}
